/* Colecao da copia da Pepper: filtros (a troca de cor do card vive no cl-interactive.js).

   O filtro dele e server-side (facets.js grava os valores em atributos do carrinho e a
   grade volta de ?section_id=api-collection, filtrada por metaobjetos que nao existem
   aqui). Na copia a grade inteira ja vem renderizada pelo Liquid, entao o filtro roda no
   cliente sobre um mapa produto -> valores (assets/cl-filters.json, colhido por
   harvest_filters.py):
     - OU dentro do mesmo filtro, E entre filtros (o comportamento do dele)
     - desktop aplica a cada clique; mobile aplica no "Show Results" (como o dele)
     - contagem "N items", rotulos ativos com remover/Clear, estado na URL (?{id}=valor)
     - opcoes sem nenhum produto NESTA colecao somem (o toggleFilterGroups dele)       */
(function () {
  'use strict';
  var sec, form, root, cards, tiles, data = null, byHandle = {};
  var CLOSE = '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false" role="presentation" class="clx-icon clx-icon-close"><path d="M1 1L20 20" stroke="#231F20"></path><path d="M20 1L1 20" stroke="#231F20"></path></svg>';

  function desktop() { return window.matchMedia('(min-width: 990px)').matches; }
  function inputs() { return Array.prototype.slice.call(form.querySelectorAll('.filter-options input[name]')); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function tokensOf(handle) {
    if (byHandle[handle]) return byHandle[handle];
    var t = {}, ix = data && data.p[handle];
    if (ix) ix.forEach(function (i) { t[data.t[i]] = 1; });
    return (byHandle[handle] = t);
  }

  function selected() {
    var sel = {};
    inputs().forEach(function (i) { if (i.checked) (sel[i.name] = sel[i.name] || []).push(i.value); });
    return sel;
  }

  function matches(handle, sel) {
    var t = tokensOf(handle);
    for (var name in sel) {
      if (!sel[name].some(function (v) { return t[name + ':' + v]; })) return false;
    }
    return true;
  }

  function apply(pushUrl) {
    if (!data) return;
    var sel = selected(), active = Object.keys(sel).length > 0, n = 0;
    cards.forEach(function (c) {
      var ok = matches(c.getAttribute('data-cl-card'), sel);
      c.hidden = !ok; if (ok) n++;
    });
    tiles.forEach(function (t) { t.hidden = active; });
    sec.querySelectorAll('.js-item-count').forEach(function (x) { x.textContent = n + ' items'; });
    var empty = sec.querySelector('.clx-collection--empty');
    if (empty) { if (n === 0) empty.setAttribute('data-cl-empty', ''); else empty.removeAttribute('data-cl-empty'); }
    var feat = sec.querySelector('.subcollection_featured_block'); if (feat) feat.hidden = n === 0;
    var main = sec.querySelector('.filter-toggler-label-main'); if (main) main.classList.toggle('active', active);
    labels();
    if (pushUrl) {
      var q = new URLSearchParams();
      inputs().forEach(function (i) { if (i.checked) q.append(i.name, i.value); });
      var s = q.toString();
      history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash);
    }
  }

  function labels() {
    var on = inputs().filter(function (i) { return i.checked; });
    var html = on.map(function (i) {
      return '<cl-facet-remove data-type="' + esc(i.name) + '" data-value="' + esc(i.value) + '">' +
        '<button type="button" class="active-filter flex-row align-center justify-between" aria-label="Remove filter: ' + esc(i.value) + '">' +
        esc(i.value) + '<span class="flex-row items-center">' + CLOSE + '</span></button></cl-facet-remove>';
    }).join('');
    var clear = on.length ? '<cl-facet-remove class="js-clear-filters clx-small-hide clx-medium-hide text-12"><span>Clear</span></cl-facet-remove>' : '';
    sec.querySelectorAll('cl-facet-labels').forEach(function (x) { x.innerHTML = html + clear; });
    sec.querySelectorAll('.mobile-facet-actions .filter-labels').forEach(function (x) { x.innerHTML = html; });
  }

  /* opcoes que nao tem nenhum produto nesta colecao somem, e o grupo inteiro junto */
  function prune() {
    var present = {};
    cards.forEach(function (c) { var t = tokensOf(c.getAttribute('data-cl-card')); for (var k in t) present[k] = 1; });
    inputs().forEach(function (i) {
      var box = i.closest('[data-value], cl-color-swatch') || i.parentElement;
      var has = present[i.name + ':' + i.value] || i.checked;
      if (has) { box.removeAttribute('data-cl-none'); box.classList.remove('clx-hidden'); } else box.setAttribute('data-cl-none', '');
    });
    form.querySelectorAll('[data-filter]').forEach(function (f) {
      var any = f.querySelector('.filter-options input[name]') && Array.prototype.some.call(f.querySelectorAll('.filter-options input[name]'), function (i) {
        var box = i.closest('[data-value], cl-color-swatch') || i.parentElement; return !box.hasAttribute('data-cl-none');
      });
      f.classList.toggle('clx-hidden', !any);
    });
    form.querySelectorAll('[data-group-content]').forEach(function (g) {
      var any = g.querySelector('[data-filter]:not(.clx-hidden)');
      var id = g.getAttribute('data-group-content');
      var lab = g.previousElementSibling, box = lab && lab.previousElementSibling;
      [g, lab, box, root.querySelector('[data-group-toggler="' + id + '"]')].forEach(function (x) {
        if (!x) return; x.classList.toggle('clx-hidden', !any);
        if (any) x.removeAttribute('aria-hidden'); else x.setAttribute('aria-hidden', 'true');
      });
    });
  }

  function toggler() { return root.querySelector('input[name="filter-toggler"]'); }
  function openDrawer(open) {
    var t = toggler(); if (!t) return;
    t.checked = open; document.body.classList.toggle('cl-filters-lock', open && !desktop());
  }

  function fromUrl() {
    var q = new URLSearchParams(location.search), any = false;
    inputs().forEach(function (i) { var on = q.getAll(i.name).indexOf(i.value) > -1; i.checked = on; any = any || on; });
    return any;
  }

  function boot() {
    sec = document.querySelector('.cl-sec-c03'); if (!sec) return;
    root = sec.querySelector('cl-collection-filters'); form = sec.querySelector('cl-facet-filters-form form'); if (!root || !form) return;
    cards = Array.prototype.slice.call(sec.querySelectorAll('.collection-products [data-cl-card]'));
    tiles = Array.prototype.slice.call(sec.querySelectorAll('.collection-products .collection-img-block'));
    // os ids dos inputs de cor (id="Buff") e de tamanho nao podem colidir com outros da pagina
    inputs().forEach(function (i, k) {
      if (!i.id || document.querySelectorAll('[id="' + CSS.escape(i.id) + '"]').length > 1) {
        var lab = i.parentElement.querySelector('label[for="' + CSS.escape(i.id) + '"]');
        i.id = 'cl-f-' + k; if (lab) lab.setAttribute('for', i.id);
      }
    });

    form.addEventListener('submit', function (e) { e.preventDefault(); apply(true); openDrawer(false); });
    form.addEventListener('change', function (e) {
      if (!e.target.name || e.target.name === 'filter-toggler' || e.target.classList.contains('group_checkbox')) return;
      if (desktop()) apply(true); else labels();
    });
    // "Show Results" (mobile) e o botao de submit escondido no desktop
    sec.querySelectorAll('.js-submit-button').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); apply(true); openDrawer(false); });
    });
    // fechar: X, overlay (e o header do tema, como no dele)
    sec.querySelectorAll('.js-filters-close').forEach(function (b) { b.addEventListener('click', function () { openDrawer(false); }); });
    var tg = toggler(); if (tg) tg.addEventListener('change', function () { document.body.classList.toggle('cl-filters-lock', tg.checked && !desktop()); });
    // chips do topo no mobile: abre o drawer ja com o grupo aberto
    root.querySelectorAll('[data-group-toggler]').forEach(function (l) {
      l.addEventListener('click', function () {
        var id = l.getAttribute('data-group-toggler');
        var gl = form.querySelector('[data-group="' + id + '"]'); if (!gl) return;
        var cb = document.getElementById(gl.getAttribute('for')); if (cb) cb.checked = true;
      });
    });
    // grupo abre/fecha pelo teclado (o label tem tabindex)
    form.querySelectorAll('label[tabindex]').forEach(function (l) {
      l.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); l.click(); } });
    });
    // remover um filtro / limpar todos
    sec.addEventListener('click', function (e) {
      var r = e.target.closest('cl-facet-remove'); if (!r) return;
      e.preventDefault();
      if (r.classList.contains('js-clear-filters')) inputs().forEach(function (i) { i.checked = false; });
      else inputs().forEach(function (i) { if (i.name === r.getAttribute('data-type') && i.value === r.getAttribute('data-value')) i.checked = false; });
      if (desktop() || r.closest('.filter-labels')) apply(true); else labels();
    });

    var src = sec.querySelector('[data-cl-filters-src]');
    var url = src && src.getAttribute('data-cl-filters-src');
    if (!url) return;
    fetch(url).then(function (r) { return r.json(); }).then(function (d) {
      data = d; prune(); var any = fromUrl(); if (any) apply(false); else labels();
    }).catch(function () { });
  }


  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
